export function formatMoney(value, currency = 'PEN') {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: currency === 'USD' ? 'USD' : 'PEN',
      minimumFractionDigits: 2,
    }).format(n);
  } catch {
    return `S/ ${n.toFixed(2)}`;
  }
}

export function formatDate(value) {
  if (!value) return '—';
  let d = value;
  if (typeof value?.toDate === 'function') d = value.toDate();
  else if (!(value instanceof Date)) d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(value) {
  if (!value) return '—';
  let d = value;
  if (typeof value?.toDate === 'function') d = value.toDate();
  else if (!(value instanceof Date)) d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function startOfTodayISO() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function sameDay(a, b) {
  if (!a || !b) return false;
  let da = a;
  let db = b;
  if (typeof da?.toDate === 'function') da = da.toDate();
  if (typeof db?.toDate === 'function') db = db.toDate();
  if (!(da instanceof Date)) da = new Date(da);
  if (!(db instanceof Date)) db = new Date(db);
  if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) return false;
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
}
